import React, {useRef, useEffect} from "react";
import {useOutsideClick} from "../../../../hooks/use-outside-click";

export type SiteIconType = 'Single-Station Site' | 'Dual-Station Site' | 'Paired Sites';

export function SiteIcon(props: {
    index: number;
    svgCoordX: number;
    svgCoordY: number;
    fillColor: string;
    dualSite: SiteIconType;
    siteID: number;
    selectedUSCRNSiteID: number;
    onClick: () => void;
    handleOutsideClick: () => void;
}) {
    const { index, svgCoordX, svgCoordY, fillColor, dualSite, siteID, selectedUSCRNSiteID, handleOutsideClick, onClick } = props;

    const shapeRef = useRef<any>();

    useOutsideClick(handleOutsideClick, shapeRef);

    const defaultRadius = 9.75;
    const defaultStrokeWidth = 2.5;
    const stroke = "#000";

    const isSelected = (): boolean => {
        return siteID === selectedUSCRNSiteID;
    }

    const getRadius = (): number => {
        return isSelected() ? defaultRadius * 4/3 : defaultRadius;
    }

    const getStrokeWidth = (): number => {
        return isSelected() ? defaultStrokeWidth * 4/3 : defaultStrokeWidth;
    }

    switch (dualSite) {
        case 'Single-Station Site':
            return (
                <circle
                    ref={shapeRef}
                    key={index}
                    cx={svgCoordX}
                    cy={svgCoordY}
                    r={getRadius()}
                    strokeWidth={getStrokeWidth()}
                    stroke={stroke}
                    fill={fillColor}
                    onClick={onClick}
                    style={{cursor: 'pointer'}}
                />
            );
        case 'Dual-Station Site': {
            return (
                <rect
                    ref={shapeRef}
                    key={index}
                    x={svgCoordX - getRadius()}
                    y={svgCoordY - getRadius()}
                    width={getRadius() * 2}
                    height={getRadius() * 2}
                    strokeWidth={getStrokeWidth()}
                    stroke={stroke}
                    fill={fillColor}
                    onClick={onClick}
                    style={{cursor: 'pointer'}}
                />
            );
        }
        case 'Paired Sites': {
            const scaledStrokeWidth = getStrokeWidth() * 1.1;
            const scaledRadius = getRadius() * 1.2
            return (
                <polygon
                    ref={shapeRef}
                    key={index}
                    points={
                        // paint diamond shape in clockwise order starting at the left point
                        `${svgCoordX - scaledRadius},${svgCoordY},${svgCoordX},${svgCoordY - scaledRadius} 
                         ${svgCoordX + scaledRadius},${svgCoordY} ${svgCoordX},${svgCoordY + scaledRadius}`
                    }
                    strokeWidth={scaledStrokeWidth}
                    stroke={stroke}
                    fill={fillColor}
                    onClick={onClick}
                    style={{cursor: 'pointer'}}
                />
            );
        }
    }
}
